const ingredients = document.querySelector('.single-recipe__ingredients ul');

if (ingredients) {
  const items = ingredients.querySelectorAll('li');
  const targetWords = /(beef|steak|roast|rib|meat|brisket)/i;

  items.forEach((item) => {
    const text = item.textContent;
    const containsTargetWord = targetWords.test(text);

    if (containsTargetWord) {
      item.addEventListener('click', (event) => {

        if (event.target.matches('input[type="checkbox"]')) {
          const checkbox = event.target;

          if (checkbox.checked) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'beefIngredientClick',
              ingredient: text.trim()
            });
          }
        }
      });
    }
  });
}


document.addEventListener('DOMContentLoaded', function () {
  const OPEN_DELAY  = 0;
  const CLOSE_DELAY = 120;

  document.querySelectorAll('.card__rating').forEach(function (wrap) {
    const tipId = wrap.getAttribute('aria-describedby');
    const tip   = tipId ? wrap.querySelector('#' + CSS.escape(tipId)) : null;
    if (!tip) return;

    let closeTimer = null;
    let openTimer  = null;

    const open = () => {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(() => {
        tip.classList.add('is-visible');
        tip.setAttribute('aria-hidden', 'false');
      }, OPEN_DELAY);
    };

    const close = () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        tip.classList.remove('is-visible');
        tip.setAttribute('aria-hidden', 'true');
      }, CLOSE_DELAY);
    };

    wrap.addEventListener('mouseenter', open);
    tip.addEventListener('mouseenter', open);

    wrap.addEventListener('mouseleave', function (e) {
      if (tip.contains(e.relatedTarget)) return;
      close();
    });

    tip.addEventListener('mouseleave', function (e) {
      if (wrap.contains(e.relatedTarget)) return;
      close();
    });

    wrap.addEventListener('focusin', open);
    wrap.addEventListener('focusout', function (e) {
      if (!wrap.contains(e.relatedTarget) && !tip.contains(e.relatedTarget)) close();
    });

    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    wrap.addEventListener('click', function () {
      if (tip.classList.contains('is-visible')) {
        close();
      } else {
        open();
      }
    });

    document.addEventListener('mousedown', function (e) {
      if (!wrap.contains(e.target) && !tip.contains(e.target)) close();
    });
    document.addEventListener('touchstart', function (e) {
      if (!wrap.contains(e.target) && !tip.contains(e.target)) close();
    });
  });
});

